<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">绑定账号详情</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                
                 <template>
                <el-table :data="tableData" height="500" border>

                    <el-table-column label="账号" prop="staff.loginName"></el-table-column>
                    <el-table-column label="姓名" prop="staff.realName"></el-table-column>
                    <el-table-column label="手机号" prop="staff.phone"></el-table-column>
                    <el-table-column label="操作" width="150">
                        <template slot-scope="scope">
                            <el-button type="primary" size="small" @click.native.prevent="handleDel(scope.$index, scope.row)">解绑</el-button>
                        </template>
                    </el-table-column>

                </el-table>
                </template>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Add",
        data() {
            return {

                loading: false,
                add_waresCode:'',
                pageSize:20,
                currentPage:1,
                showModalAdd:false,
                tableData:[],
                waresList:[],
                status:0,
                totalItems: 0,
                th:0,
                statusValue:['老人状态','正常','禁用'],
                name:'',
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    medicinerCode:'',
                },
                medicinerCode:'',
                rules:{
                    name:[
                        { required: true, message: '物品名称', trigger: 'blur' },
                    ],
                    sort:[
                        { required: true, message: '请输入库存', trigger: 'blur' },
                        { type: 'number', message: '库存必须为数字值'}
                    ],
                }


            }
        },

        methods: {
            init(row){
                this.medicinerCode=row.medicinerCode
                this.getList();
            },
            closeSelf() {
                this.$emit("closeInfo");
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },
            handleDel(index,row){
                this.$confirm('此操作解绑此账号, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios({
                        method: 'post',
                        url: this.$institutionUrl+'MedicinerStaffRel/Del',
                        data: {
                            timeStr:timeStr,
                            sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                            staffCode: getStaffCode(),
                            medicinerCode:this.medicinerCode,
                            medicinerStaffCode:row.staffCode,
                        }
                    }).then((response)=> {
                        if(response.data.error == 0){
                            this.$message({
                                type: 'success',
                                message: '解绑成功!'
                            });
                            this.getList()
                        }else if(response.data.error == 1){
                            this.$message(response.data.message);
                        }else{
                            console.log(response.data.message);
                        }
                    }).catch(function (error) {
                        console.log(error);
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消解绑'
                    });          
                });
            },
            changeWares(selVal){
                this.add_waresCode=selVal;
            },
            statusTitle(row){
                if(row.status == 0){
                    return "正常";
                }
                if(row.status == 1){
                    return "禁用";
                }
                return "其它";
            },
            getList(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+'MedicinerStaffRel/RelDetails',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        medicinerCode:this.medicinerCode,
                    }
                }).then((response)=> {
                    if(response.data.error == 0){
                        this.tableData=response.data.data
                    }else if(response.data.error == 1){
                        this.$message(response.data.message);
                    }else{
                        console.log(response.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
        }
    }
</script>

<style  lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

    .modal {
        background-color: #fff;
        box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        overflow-x:auto;
        display: flex;
        flex-direction: column;
        border-radius: 10px;
        width:800px;

    .modal-header {
        border-bottom: 1px solid #eee;
        color: #313131;
        justify-content: space-between;
        padding: 10px;
        display: flex;
    }
    .modal-body {
        position: relative;
        padding: 20px 20px;
        z-index: 99;
        height: 100%;
    }
    .modal-footer {
        border-top: 1px solid #eee;
        justify-content: flex-end;
        padding: 15px;
        display: flex;
    }


    }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }
</style>